<script>
export default {}
</script>

<template>
  <div>
    <slot></slot>
    <div :class="$style.contentContainer">
      <slot name="content" />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.contentContainer {
  position: relative;
  padding: 20px 20px;
  background-color: $white;
  border: 2px solid $light-gray;
  border-radius: 8px;
}
</style>
